import { cva } from 'class-variance-authority';
import React from 'react';

const textFieldCVA = cva('si-input', {
  variants: {
    isError: {
      true: 'si-error'
    }
  }
});

const TextField = ({
  type = 'text',
  placeholder = 'Enter your email ID',
  errorMessage,
  onChange,
  value,
  isError
}) => {
  return (
    <div className='si-form'>
      <div className={textFieldCVA({ isError })}>
        <input type={type} onChange={onChange} value={value} placeholder={placeholder} />
        {isError && (
          <div className='si-msg--error'>
            <i className='qz-info'></i>
            <span>{errorMessage}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TextField;
